import { isBoolean, some } from 'es-toolkit/compat';
import { NULL_VALUE_DISPLAY_NAME } from 'utils/helpers';

// Discrete filters send this value to match items where the field is not set.
export const UNSPECIFIED_FILTER_VALUE = '__unspecified__';

export const UNSPECIFIED_FILTER_LABEL = NULL_VALUE_DISPLAY_NAME;

// Boolean filters already treat a missing value as "No".
export const withUnspecifiedFilterOption = <Option extends { value: unknown; label: string }>(
  field: { excludeUnspecifiedFilterOption?: boolean },
  options: Option[] | undefined
): Array<Option | { value: string; label: string }> =>
  field.excludeUnspecifiedFilterOption || some(options, (option) => isBoolean(option.value))
    ? options ?? []
    : [...(options ?? []), { value: UNSPECIFIED_FILTER_VALUE, label: UNSPECIFIED_FILTER_LABEL }];
